import _ from 'lodash'
import React, { useEffect, useState } from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { Button, Loader, Message, Popup, Segment } from 'semantic-ui-react'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import SwiperCore, { Pagination } from 'swiper/core'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import PlaceServiceAPI from '../../apis/PlaceServiceAPI'
import { addRecaptchaToURL } from '../../common/util'
import { NT_PLACE_NAMES_COMMITTEE_LINK, NT_PLACE_NAMES_PRINT_LINK, PLACENAME_DOCUMENT_BASE } from '../../environment'

import PlacenameTab1 from './placename-tabs/PlacenameTab1'
import PlacenameTab2 from './placename-tabs/PlacenameTab2'
import PlacenameTab3 from './placename-tabs/PlacenameTab3'
import PlacenameTab4 from './placename-tabs/PlacenameTab4'

import './PlacenameDetails.css'
import { PlacenameDataTypeProp, PlacenameDocument } from './slice'

// install Swiper modules
SwiperCore.use([Pagination])

export default function PlacenameDetails({ placenameData }: PlacenameDataTypeProp) {
  const [placenameMedia, setPlacenameMedia] = useState<PlacenameDocument[]>([])
  const [audioPronunciation, setAudioPronunciation] = useState<PlacenameDocument | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isplaying, setIsPlaying] = useState(false)

  useEffect(() => {
    if (placenameData) {
      setIsLoading(true)
      callMediaAsync()
    }
    return () => {
      setAudioPronunciation(null)
      setIsLoading(true)
      setIsPlaying(false)
      setPlacenameMedia([])
    }
  }, [placenameData])

  const callMediaAsync = async () => {
    const documents = await PlaceServiceAPI.fetchPlacenameDocumentsFor(placenameData.placeId)
    setIsLoading(false)
    if (documents && documents.length > 0) {
      setPlacenameMedia(documents)
      documents.filter(m => m.category === 'MEDIA_AUDIO_PRONUNCIATION').forEach(media => {
        setAudioPronunciation(media)
      })
    }
  }

  return (
    <TransitionGroup className={'placenameDetailsTransitionContainer'}>
      <CSSTransition
        key={getPlacenameDataKey()}
        appear={true}
        in={true}
        timeout={1000}
        classNames="parcel-details">
        <div className={'placenameDetailsContainer'}>
          <div className={'placenameDetails'}>
            <Message size="tiny" className={'info-message'}>
              <p>If you know of any information about this place name which does not appear in this
                extract, please let the Place Names Committee know by completing a &nbsp;
                <a href={NT_PLACE_NAMES_COMMITTEE_LINK} className="linkUnderline" target="_blank"
                   rel="noopener noreferrer">submission form</a>.</p>
            </Message>

            <div className={'button-icon'}>
              <a href={`${NT_PLACE_NAMES_PRINT_LINK}?id=${(placenameData.placeId)}`}
                 className="linkUnderline" target="_blank" rel="noopener noreferrer">
                <Popup content="Print Extract"
                       trigger={<Button placeholder="Print Extract" size="tiny" icon="print"/>}/>
              </a>
            </div>
            <Segment attached="top" className={'panel-title'}>
              <h3 className="placenameDetailsHeader">Place Names Register Extract</h3>
            </Segment>
            {(placenameData && audioPronunciation) &&
                <div className={'button-icon'}>
                  {
                    <audio id={'pronunciation'}>

                    </audio>}
                  {(!isplaying) &&
                      <button id="pronunciation-button" placeholder="Play audio" className="ui tiny icon button"
                              onClick={(e) => playPronunciationAudio(e, audioPronunciation)}>
                          <i aria-hidden="true" className="volume up icon"></i>
                      </button>}
                    <Loader className="audio-Loader" size="small" active={isplaying}></Loader>
                </div>
            }
            <Segment attached className={'detail-title'}>
              <h3
                className="parcelDetailsSubject">{(placenameData.officialName)} ({(placenameData.typeDesignation)}) </h3>
              {(placenameData.phoneticSpelling) &&
                  <p className="placePhoneticSpelling">{(placenameData.phoneticSpelling)}</p>}
            </Segment>
            <Segment attached className={'detailsSegment'}>
              <Swiper slidesPerView={1} spaceBetween={30} loop={true} autoHeight pagination={{
                el: '.place-pagination',
                'clickable': true,
                'renderBullet': function (index, className) {
                  return '<span class="' + className + '">' + (index + 1) + '</span>'
                },
              }} className="placeSwiper">
                <SwiperSlide>
                  <div className={'placeSchemeInformation'}>
                    <PlacenameTab1 placenameData={placenameData}/>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={'placeSchemeInformation'}>
                    <PlacenameTab2 placenameData={placenameData}/>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={'placeSchemeInformation'}>
                    <PlacenameTab3 placenameData={placenameData}/>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={'placeSchemeInformation'}>
                    <PlacenameTab4 placenameMedia={placenameMedia} isLoading={isLoading}/>
                  </div>
                </SwiperSlide>
                <div className={'place-pagination'}></div>
              </Swiper>
            </Segment>
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  )

  function getPlacenameDataKey() {
    if (_.isEmpty(placenameData)) {
      return 'empty'
    } else {
      return placenameData.placeId
    }
  }

  function playPronunciationAudio(e: React.MouseEvent, audioPronunciation: PlacenameDocument) {
    setIsPlaying(true)
    e.preventDefault()
    addRecaptchaToURL(PLACENAME_DOCUMENT_BASE + audioPronunciation.placeId + '/media/' + audioPronunciation.mediaId).then(v => {
      let audio = document.getElementById('pronunciation') as HTMLAudioElement
      if (audio) {
        audio.src = v
        try {
          audio.play().then(e => {
            setIsPlaying(false)
          })
        } catch (err) {
        }
      }


    })
  }
}
